import { failContract } from "./errors.js";
function fail(path, message) {
    return failContract(path, message);
}
export function expectObject(value, path) {
    if (typeof value !== "object" || value == null || Array.isArray(value)) {
        fail(path, "expected object");
    }
    return value;
}
export function expectString(value, path) {
    if (typeof value !== "string") {
        fail(path, "expected string");
    }
    return value;
}
export function expectNumber(value, path) {
    if (typeof value !== "number" || Number.isNaN(value)) {
        fail(path, "expected number");
    }
    return value;
}
export function expectBoolean(value, path) {
    if (typeof value !== "boolean") {
        fail(path, "expected boolean");
    }
    return value;
}
export function expectOptionalString(value, path) {
    if (value == null) {
        return undefined;
    }
    return expectString(value, path);
}
export function expectOptionalNumber(value, path) {
    if (value == null) {
        return undefined;
    }
    return expectNumber(value, path);
}
export function expectOptionalBoolean(value, path) {
    if (value == null) {
        return undefined;
    }
    return expectBoolean(value, path);
}
export function expectArray(value, path, parseValue) {
    if (!Array.isArray(value)) {
        fail(path, "expected array");
    }
    return value.map((entry, index) => parseValue(entry, `${path}[${String(index)}]`));
}
export function expectObjectArray(value, path, parseValue) {
    if (!Array.isArray(value)) {
        fail(path, "expected array");
    }
    return value.map((entry, index) => {
        const itemPath = `${path}[${String(index)}]`;
        return parseValue(expectObject(entry, itemPath), itemPath);
    });
}
export function readField(object, field, path) {
    if (!(field in object)) {
        fail(`${path}.${field}`, "missing field");
    }
    return object[field];
}
export function readOptionalField(object, field) {
    if (!(field in object)) {
        return undefined;
    }
    return object[field];
}
export function parseErrorBody(value, path = "$") {
    const object = expectObject(value, path);
    const target = expectOptionalString(readOptionalField(object, "target"), `${path}.target`);
    return {
        code: expectString(readField(object, "code", path), `${path}.code`),
        message: expectString(readField(object, "message", path), `${path}.message`),
        ...(target == null ? {} : { target }),
    };
}
export function parseErrorResponse(value, path = "$") {
    const object = expectObject(value, path);
    return {
        error: parseErrorBody(readField(object, "error", path), `${path}.error`),
    };
}
export function parseIndexedPage(value, path, parseItem) {
    const object = expectObject(value, path);
    const nextCursor = expectOptionalString(readOptionalField(object, "nextCursor"), `${path}.nextCursor`);
    const totalCount = expectOptionalNumber(readOptionalField(object, "totalCount"), `${path}.totalCount`);
    return {
        asOfHeight: expectNumber(readField(object, "asOfHeight", path), `${path}.asOfHeight`),
        ...(totalCount == null ? {} : { totalCount }),
        value: expectArray(readField(object, "value", path), `${path}.value`, parseItem),
        ...(nextCursor == null ? {} : { nextCursor }),
    };
}
export function parseLivePage(value, path, parseItem) {
    const object = expectObject(value, path);
    const nextCursor = expectOptionalString(readOptionalField(object, "nextCursor"), `${path}.nextCursor`);
    const totalCount = expectOptionalNumber(readOptionalField(object, "totalCount"), `${path}.totalCount`);
    return {
        ...(totalCount == null ? {} : { totalCount }),
        value: expectArray(readField(object, "value", path), `${path}.value`, parseItem),
        ...(nextCursor == null ? {} : { nextCursor }),
    };
}
//# sourceMappingURL=json.js.map